import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Primary } from "@cinch-labs/design-system";
import { useLatestVehicles } from "@cinch-nx/landing-ui-shared";
import { VehicleCard } from "@cinch-nx/landing-ui-shared";
import { TrackingEventTypes, useAnalytics } from "@cinch-nx/shared-analytics";
import { Wrapper } from "@cinch-nx/shared-ui";
import styles from "./latest-cars-section.module.css";
export const LatestCarsSection = ({ tags , fuelType , seats , colour , bodyType , numberOfVehicles  })=>{
    const { data , countOfData , browseButtonUrl , error  } = useLatestVehicles({
        tags: tags,
        fuelType: fuelType,
        bodyType: bodyType,
        seats: seats,
        colour: colour,
        numberOfVehicles: numberOfVehicles,
        caller: "seo-pages"
    });
    const { trackEvent  } = useAnalytics();
    if (!data) {
        return /*#__PURE__*/ _jsx("div", {
            children: "Loading..."
        });
    }
    if (error) {
        console.log(error);
        return null;
    }
    if (data.vehicleListings.length === 0) {
        return null;
    }
    return /*#__PURE__*/ _jsx("section", {
        className: styles.wrapper,
        children: /*#__PURE__*/ _jsxs(Wrapper, {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: styles.cardContainer,
                    children: data.vehicleListings.map((vehicle)=>/*#__PURE__*/ _jsx(VehicleCard, {
                            id: vehicle.vehicleId,
                            vehicle: vehicle,
                            isAvailable: vehicle.isAvailable,
                            isSaved: false,
                            isPending: false,
                            discountInPence: vehicle.discountInPence,
                            showActions: false,
                            onCardClick: ()=>{
                                trackEvent({
                                    eventName: `SEO pages - View fpa card click`,
                                    data: {
                                        event: {
                                            name: "click",
                                            category: "button",
                                            label: `seo_view_fpa_card`,
                                            value: vehicle
                                        }
                                    },
                                    type: TrackingEventTypes.ADOBE
                                });
                            }
                        }, vehicle.vehicleId))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: styles.buttonWrapper,
                    children: /*#__PURE__*/ _jsxs(Primary, {
                        element: "a",
                        href: browseButtonUrl,
                        onClick: ()=>{
                            trackEvent({
                                eventName: `SEO pages - Browse cars click`,
                                data: {
                                    event: {
                                        name: "click",
                                        category: "button",
                                        label: `Browse cars button on SEO pages`
                                    }
                                },
                                type: TrackingEventTypes.ADOBE
                            });
                        },
                        classNames: {
                            button: styles.browseCarsButton
                        },
                        children: [
                            "Browse ",
                            countOfData ? countOfData : "all",
                            " cars"
                        ]
                    })
                })
            ]
        })
    });
};
